import React, { useEffect, useState } from 'react';
import { isMobile, isTablet } from "react-device-detect";
import Button from '@material-ui/core/Button';

import * as RemindersApi from "../../../Common/Apis/RemindersApi";
import ContentsWrapper from '../../../Public/Wrapper/ContentsWrapper';
import Header from '../../../Public/Header/Header';
import { useSpinner } from '../../../../core/contexts/SpinnerContext';
import ListItem from "./ListItem";
import EditSubCategoryDialog from "../Dialog/EditSubCategoryDialog";
import { ISubCategory } from '../store/ReminderStore';

const Subcategory = () => {

  const { setSpinner } = useSpinner();

  const [listData, setListData] = useState({ Data: [], Paging: {} });
  const [pageSize, setpageSize] = useState((isMobile && !isTablet) ? 10 : 100);
  const [pageNo, setpageNo] = useState(1);
  const [editItem, setEditItem] = useState<ISubCategory | undefined>();

  const pageSizeChanged = (i: number) => {
    setpageSize(i);
    setpageNo(1);
    getList(1, i);
  };

  const pageNoChanged = (i: number) => {
    setpageNo(i);
    getList(i, pageSize);
  };

  const closeSubCategoryDialog = (isRefresh: boolean) => {
    if (isRefresh) {
      getList(pageNo, pageSize);
    }

    setEditItem(undefined);

  };

  const addSubcategory = () => {
    setEditItem({
      "Id": "",
      "IsSystemManaged": false,
      "Name": ""
    });

  };

  const getList = async (_pageNo: number, _pageSize: number) => {


    setSpinner(true);

    try {

      const resData = await RemindersApi.getSubCategoryList(_pageNo, _pageSize);

      setListData(resData);

      //console.log('resData', resData);

    } catch (err) {
      console.log('err', err);
    }

    setSpinner(false);
  };

  useEffect(() => {
    getList(1, pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ContentsWrapper header={<Header title="Subcategory" />}>
      <div className="row no-gutters">
        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <div className="card">
              <div className="card-body">

                <div className="row ">
                  <div className="col">
                    <div className="form-group">
                      <Button
                        type="button"
                        className=" ml-3"
                        style={{ fontWeight: '600' }}
                        variant="contained"
                        color="primary"
                        onClick={() => getList(1, pageSize)}
                      >
                        Refresh
                      </Button>
                      <Button
                        type="button"
                        className=" ml-3"
                        style={{ fontWeight: '600' }}
                        variant="contained"
                        color="primary"
                        onClick={() => addSubcategory()}
                      >
                        Add
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            {listData && <ListItem
              items={listData.Data}
              paging={listData.Paging}
              pageSizeChanged={pageSizeChanged}
              pageNoChanged={pageNoChanged}
              editItemClicked={e => { console.log(e); setEditItem(e); }}
            />}

          </div>
        </div>
      </div>
      {
        editItem &&
        <EditSubCategoryDialog

          item={editItem}
          onClose={closeSubCategoryDialog}
        />
      }
    </ContentsWrapper >
  );

};

export default Subcategory;